import React from 'react';

export const Risks20 = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.34089 4.95545C9.62473 4.43244 10.3754 4.43243 10.6592 4.95545L16.8735 16.4061C17.1448 16.9058 16.783 17.5138 16.2144 17.5138H3.78577C3.21718 17.5138 2.85538 16.9058 3.12659 16.4061L9.34089 4.95545Z"
      stroke={color || '#7D7A9A'}
      strokeWidth="1.5"
    />
    <path
      d="M10.75 9.13281C10.75 8.7186 10.4142 8.38281 10 8.38281C9.58579 8.38281 9.25 8.7186 9.25 9.13281H10.75ZM9.25 11.9338C9.25 12.348 9.58579 12.6838 10 12.6838C10.4142 12.6838 10.75 12.348 10.75 11.9338H9.25ZM9.25 9.13281V11.9338H10.75V9.13281H9.25Z"
      fill={color || '#7D7A9A'}
    />
    <circle cx="10" cy="14.5844" r="1.12252" fill={color || '#7D7A9A'} />
  </svg>
);
